<template>
    <div>
        <el-select class="filterItem-field" v-model="filterItem.field" placeholder="请选择一个过滤字段" clearable filterable>
            <el-option
                v-for="item in supportSelectedFields"
                :key="item.value"
                :label="item.text"
                :value="item.value"
                />
        </el-select>

        <el-select class="filterItem-operator" v-model="filterItem.operator" filterable :disabled="disabled">
            <el-option
                v-for="item in operatorOptions"
                :key="item.value"
                :label="item.text"
                :value="item.value"
                />
        </el-select>

        <component class="filterItem-value" :is="filterItem.fieldType + 'Filter'"
            :filterItem="filterItem"
            :contentDefinition="contentDefinition">
        </component>

        <el-button class="qwe-square" @click="add"><el-icon><plus /></el-icon></el-button>
        <el-button class="qwe-square" @click="remove"><el-icon><minus /></el-icon></el-button>
    </div>
</template>

<style>
    .qwe-square{
        padding: 8px !important;
    }

    .filterItem-operator{
        width: 130px;
        max-width: 130px;
        margin-right: 8px;
    }
    
    .filterItem-field{
        max-width: 222px;
        margin-right: 8px;
    }
    .filterItem-value{
        width:260px !important;
        margin-right: 8px;
    }
    .filterItem-value>.el-date-editor{
        box-sizing: border-box;
    }
</style>

<script>
    import { Plus, Minus } from '@element-plus/icons-vue';
    import filterItem from '../SingleFilterItem';
    import { qweIsEmpty } from '../../../common/commonHelper';

    export default {
        name:"filterItem",

        mixins:[filterItem],

        components:{
            'plus':Plus,
            'minus':Minus
        },

        computed:{
            disabled:function(){
                return qweIsEmpty(this.filterItem.field);
            }
        }
    }
</script>